import ScrollSnap from "../ScrollSnap"


const PackCardLoader = () => {

    return(
        <section className="incoming-home__packages">
            <div className="pack-card-container">
            <ScrollSnap
            type="mandatory" 
            columnGap="16" 
            columnGapDt="16" 
            columnGapDtLarge="16">
                <div className="pack-card pack-card-loader">
                    <div className="card-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div className="pack-card pack-card-loader">
                    <div className="card-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div className="pack-card pack-card-loader">
                    <div className="card-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </ScrollSnap>
        </div>
        </section>
    )
}

export default PackCardLoader